import { PageGrid } from './PageGrid';
import { SiteBrandLink } from './SiteBrandLink';
import { SiteFooterNavGroup } from './SiteFooterNavGroup';
import { SiteFadeInMount } from './SiteFadeIn';
import { SITE_FOOTER_SECTIONS } from '../constants/siteNav';
import {
  formatSiteFooterLegal,
  SITE_TAGLINE_LINE_ONE,
  SITE_TAGLINE_LINE_TWO,
} from '../constants/siteBrand';

interface SiteFooterProps {
  /** When false, footer is not mounted (waits for page content). */
  ready?: boolean;
}

export function SiteFooter({ ready = true }: SiteFooterProps) {
  if (!ready) {
    return null;
  }

  const legal = formatSiteFooterLegal(new Date().getFullYear());

  return (
    <SiteFadeInMount>
      <PageGrid as="footer" className="site-footer">
        <div className="site-footer__stack col-span-full">
          <div className="site-footer__main">
            <div className="site-footer__brand">
              <SiteBrandLink />
              <p className="text-body-md text-text-primary">
                {SITE_TAGLINE_LINE_ONE}
                <br />
                {SITE_TAGLINE_LINE_TWO}
              </p>
            </div>

            <div className="site-footer__columns">
              {SITE_FOOTER_SECTIONS.map((section) => (
                <SiteFooterNavGroup
                  key={section.title}
                  title={section.title}
                  links={section.links}
                />
              ))}
            </div>
          </div>

          <p className="text-body-md text-text-quaternary">{legal}</p>
        </div>
      </PageGrid>
    </SiteFadeInMount>
  );
}
